// extracted by mini-css-extract-plugin
export default {"list":"list--3HSm7","bullet":"bullet--2kogK","step":"step--1tPmQ"};